import { BrandRepository } from '../../domain/repositories/BrandRepository'
import { BrandModel } from '../models/BrandModel'
import { BrandMiniModel } from '../models/BrandMiniModel'
import { CreateUpdateBrandModel } from '../models/CreateUpdateBrandModel'
import { BrandsFilterModel } from '../models/BrandsFilterModel'
import { BrandsService, type PostBrandRequestAdmin } from '@/backend/market'
import type { CreateUpdateBrandEntity } from '../../domain/entities/CreateUpdateBrandEntity'
import type { BrandFilterEntity } from '../../domain/entities/BrandsFilterEntity'
import type { BrandEntity } from '../../domain/entities/BrandEntity'
import type { BrandResponseEntity } from '../../domain/entities/BrandResponseEntity'

export class BrandRepositoryImpl implements BrandRepository {
  async getBrands(filterData: BrandFilterEntity): Promise<BrandResponseEntity | { error: true }> {
    try {
      const brandsFilterModel = new BrandsFilterModel(filterData)
      const response = await BrandsService.getBrandsAdmin(brandsFilterModel)
      const brandModels = response.items?.map((brand) => new BrandMiniModel(brand)) ?? []
      return {
        ...response,
        items: brandModels
      }
    } catch {
      return { error: true }
    }
  }

  async getBrandById(id: number): Promise<BrandEntity | { error: true }> {
    try {
      const response = await BrandsService.getBrandAdmin({ id })
      const brandModel = new BrandModel(response)
      return brandModel
    } catch {
      return { error: true }
    }
  }

  async createBrand(data: CreateUpdateBrandEntity): Promise<{ success: true } | { error: true }> {
    const createUpdateBrandModel = new CreateUpdateBrandModel(data)
    try {
       await BrandsService.postBrandAdmin({
        requestBody: createUpdateBrandModel as PostBrandRequestAdmin
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async updateBrand(
    id: number,
    data: CreateUpdateBrandEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateBrandModel = new CreateUpdateBrandModel(data)
    try {
      await BrandsService.putBrandAdmin({
        id,
        requestBody: createUpdateBrandModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteBrand(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await BrandsService.deleteBrandAdmin({ id })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
